/** Кому открыт раздел «Опционы», решает сервер (backend_v2/access.py; список
 *  правится в админке) и сообщает в /api/settings → `features`. Сервер
 *  проверяет то же сам (403) — здесь лишь прячем пункты меню. */
import type { UserSettings } from '../types';

type Who = Pick<UserSettings, 'username' | 'features'> | null | undefined;

export const canSeeOptions = (user: Who): boolean =>
  !!user?.username && Array.isArray(user.features) && user.features.includes('options');
